import React from "react";

const severityStyles = {
  info: "bg-blue-50 text-blue-900 border-blue-200",
  warning: "bg-amber-50 text-amber-900 border-amber-200",
  danger: "bg-red-50 text-red-900 border-red-200",
};

export default function AnnouncementBanner({ announcement, onOpen }) {
  if (!announcement) return null;

  const cls =
    severityStyles[announcement.severity] ||
    "bg-neutral-50 text-neutral-900 border-neutral-200";

  return (
    <div className={`w-full border-b ${cls}`}>
      <div className="mx-auto max-w-5xl px-4 py-3">
        <div className="flex items-start gap-3">
          <div className="flex-1">
            <p className="text-sm font-semibold leading-5">
              {announcement.title || "Important update"}
            </p>
            <p className="text-sm leading-5 opacity-90">
              {announcement.message}
            </p>
          </div>

          <button
            type="button"
            onClick={onOpen}
            className="shrink-0 rounded-md border border-current/20 px-3 py-1.5 text-sm font-medium"
          >
            Details
          </button>
        </div>
      </div>
    </div>
  );
}